<template>
  <div class="mb-5">
    <div class="fv-row">
      <!--begin::Label-->
      <label class="form-label">{{ label }}</label>
      <!--end::Label-->
      <!--begin::Input-->
      <input
        type="text"
        name="sku"
        class="form-control"
        placeholder=""
        :value="modelValue"
        @input="updateValue"
      />
      <!--end::Input-->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: String,
    label: String,
  },
  methods: {
    updateValue(event) {
      this.$emit("update:modelValue", event.target.value);
    },
  },
};
</script>
